import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";
import {ConditionsProps} from "../utils/segmentBuilder";

export interface DeleteSegmentRequest {
    domain: string;
    segmentId: number;
}


export const deleteSegment = async ({ domain, segmentId }: DeleteSegmentRequest): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `segment`,
        method: 'DELETE',
        headers: {
            "Content-Type": "application/json",
        },
        params: {
            domain,
            segmentId,
        },
        domain,
        isEncrypted: true,
    });
}